import "./RecommendedForYou.css";
import recommendedIcons from "../../../utils/recommendedIcons";

const RecommendedForYou = ({ foods = [], onSelect }) => {
  return (
    <section className="recommended-section">
      <div className="section-header">
        <h2>Recommended For You</h2>
        <button>View All</button>
      </div>

      <div className="recommended-grid">
        {foods.map((food, index) => (
          <div
            key={index}
            className="recommended-card"
            onClick={() => onSelect(food.name)}
          >
            <div className="recommended-icon">
              {recommendedIcons[food.name]}
            </div>

            <h4>{food.name}</h4>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RecommendedForYou;